<template>
    <div class="MessageContent">
        <v-spacer v-if="!isUser"></v-spacer>
        <div style="background: #fff" class="message-text-container">
            <div class="message-text" :class="isUser ? 'user' : 'bot'">
                <span v-html="replaceLinkInTextContent(content.text)"></span>
                <span v-if="needViewMore && showViewMore" @click="toggleViewMore" class="view-more">
                    {{ $t('viewMore') }}
                </span>
            </div>
            <div style="padding: 8px" v-if="content.buttons && content.buttons.length > 0">
                <button class="message-btn" v-for="(b, ib) in content.buttons" :key="ib">
                    {{ b.title }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentRequestUserLocation",
    extends: MessageContent
}
</script>
